const SUPPORTED_LOCALES = [
    'cs-CZ',
    'da-DK',
    'de-DE',
    'en-GB',
    'es-ES',
    'et-EE',
    'fr-FR',
    'it-IT',
    'lt-LT',
    'lv-LV',
    'nl-NL',
    'pl-PL',
    'pt-PT',
    'ro-RO',
    'sk-SK',
    'bg-BG',
    'fi-FI',
    'el-GR',
    'hr-HR',
    'hu-HU',
    'no-NO',
    'sv-SE',
].sort();

export default SUPPORTED_LOCALES;
